export default __webpack_public_path__ + "static/media/mailbox.68330252.svg";